<template>
  <div id="app" @keydown="handleKeyDown">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  
  },
  methods: {
    handleKeyDown(event) {
      // 屏蔽回车键 (Enter键的keyCode是13)
      if (event.keyCode === 13 || event.key === 'Enter') {
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
    }
  },
  mounted() {
    // 添加全局键盘事件监听器
    document.addEventListener('keydown', this.handleKeyDown, true);

    // 添加关闭洗衣清理
    window.addEventListener('beforeunload', () => {
      localStorage.removeItem('laundry_headers');
    });
  },
  
  beforeDestroy() {
    // 移除事件监听器，避免内存泄漏
    document.removeEventListener('keydown', this.handleKeyDown, true);
    window.removeEventListener('beforeunload', this.clearStorage);
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
}
</style>
